import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import '@/MuiClassNameSetup'

// oxlint-disable-next-line typescript/no-floating-promises
Promise.all([import('@/Root'), import('@/Routes')]).then(
  ([{ default: render }, { default: AppRoutes }]) => {
    // oxlint-disable-next-line typescript/no-floating-promises
    render(AppRoutes)
  }
)

export {}
